<div class="container-fluid py-3">
  <div class="row">

    <!-- Header card skeleton (reemplaza stats: mes, overdue/pending/done, monto) -->
    <div class="col-12 bg-white py-3 px-3 rounded mb-2">
      <div class="row placeholder-glow align-items-center">
        <div class="col d-flex align-items-center">
          <span class="placeholder col-5 rounded" style="height: 1.5rem;"></span>
        </div>
        <div class="col">
          <div class="row">
            <div class="col d-flex align-items-center">
              <span class="placeholder col-8 rounded"></span>
            </div>
            <div class="col d-flex align-items-center">
              <span class="placeholder col-8 rounded"></span>
            </div>
            <div class="col d-flex align-items-center">
              <span class="placeholder col-8 rounded"></span>
            </div>
          </div>
        </div>
        <div class="col text-center">
          <span class="placeholder col-6 rounded"></span>
        </div>
      </div>
    </div>

    <!-- Action bar skeleton (reemplaza botón "Descargar reporte") -->
    <div class="col-12 bg-white py-3 px-3 rounded mb-3">
      <div class="placeholder-glow">
        <span class="placeholder col-3 rounded" style="height: 2.2rem;"></span>
      </div>
    </div>

    <!-- Grupos de calles skeleton (2 grupos × 4 filas) -->
    @for(group of skeletonGroups; track $index) {

      <!-- Label de calle -->
      <div class="col-12 mb-1">
        <div class="placeholder-glow">
          <span class="placeholder col-2 rounded"></span>
        </div>
      </div>

      <!-- Card de filas -->
      <div class="col-12 bg-white px-3 rounded mb-4">
        <div class="row">

          @for(row of skeletonRows; track $index) {
            <div class="col-12 py-2 border-bottom">
              <div class="row align-items-center placeholder-glow">

                <!-- Número -->
                <div class="col-2 col-lg-1 d-flex align-items-center" style="min-width: 0;">
                  <span class="placeholder col-8 rounded"></span>
                </div>

                <!-- Nombre -->
                <div class="col-4 col-lg-2 d-flex align-items-center" style="min-width: 0;">
                  <span class="placeholder col-9 rounded"></span>
                </div>

                <!-- Monto -->
                <div class="col-2 col-lg-1 d-flex align-items-center justify-content-end" style="min-width: 0;">
                  <span class="placeholder col-7 rounded"></span>
                </div>

                <!-- Notas propietario (solo desktop) -->
                <div class="col-lg-1 d-none d-lg-flex align-items-center" style="min-width: 0;">
                  <span class="placeholder col-8 rounded"></span>
                </div>

                <!-- Notas pago (solo desktop) -->
                <div class="col-lg-2 d-none d-lg-flex align-items-center" style="min-width: 0;">
                  <span class="placeholder col-9 rounded"></span>
                </div>

                <!-- Status badge -->
                <div class="col-4 col-lg-2 d-flex align-items-center" style="min-width: 0;">
                  <span class="placeholder col-6 rounded-pill" style="height: 1.4rem;"></span>
                </div>

                <!-- Acciones: toggle + 3 botones circulares -->
                <div class="col-12 col-lg-3 d-flex align-items-center justify-content-around justify-content-lg-start" style="min-width: 0;">
                  <span class="placeholder rounded" style="width: 2.8rem; height: 1.5rem;"></span>
                  <span class="placeholder rounded-circle me-2" style="width: 2rem; height: 2rem;"></span>
                  <span class="placeholder rounded-circle me-2" style="width: 2rem; height: 2rem;"></span>
                  <span class="placeholder rounded-circle me-2" style="width: 2rem; height: 2rem;"></span>
                </div>

              </div>
            </div>
          }

        </div>
      </div>

    }

  </div>
</div>
